import { Component, OnInit } from '@angular/core';
import { ParamMap } from '@angular/router';
import { Globals } from "../../_models/globals";
import { ApiIntegration } from "../../_services/api.integration";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';

@Component({
  selector: 'app-amzn-auth',
  templateUrl: './amzn-auth.component.html',
  styleUrls: ['./amzn-auth.component.scss'],
})
export class AmznAuthComponent implements OnInit {
  spapi_oauth_code: string = '';
  state: string = '';
  selling_partner_id: string = '';
  constructor(private alertService: AlertService, private g: Globals, private api: ApiIntegration, private http: HttpClient, private route: ActivatedRoute, private router: Router) {
    this.route.queryParams
      .subscribe((params: any) => {
        if ((params || {}).spapi_oauth_code) {
          this.spapi_oauth_code = params.spapi_oauth_code;
        }
        if ((params || {}).state) {
          this.state = params.state;
        }
        if ((params || {}).selling_partner_id) {
          this.selling_partner_id = params.selling_partner_id;
        }
      });
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    // header1 = header1.append('Authorization', 'Bearer ' + this.local.get('jwt'));
    this.http.post(environment.apiUrl + 'api/AuthorizeAmazon', {
      "accountOwnerId": this.state,
      "organizationId": 1,
      "connectionName": "AMAZON",
      "sellingPartnerId": this.selling_partner_id,
      "spApiOAuthCode": this.spapi_oauth_code
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Amazon', data['message']);
          if (data['storeId']) {
            /* sessionStorage.setItem('jwt', data['token']);
            this.session.set('jwt', data['token']); */
            sessionStorage.setItem('jwt', data['token']);
            this.router.navigate(['/admin/amazonManageStoreManagement', { type: 'AMAZON', id: data['storeId'] }]);
          }
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
    console.log(this.spapi_oauth_code, this.state, this.selling_partner_id);
  }

  ngOnInit() { }

}
